import React from "react";
import { VerifyEmail } from "../VerifyPage";
import { GetQueryString } from "../../Utils";
import { en, zh } from "../../Utils/i10";

export const VerifyResetPin = () => {
  const translateI10 = () => {
    const lan = GetQueryString("lang").toLocaleLowerCase();
    const lanType = lan.includes("en") ? true : false;
    return lanType ? en() : zh();
  };

  const getStatus = () => {
    const status = GetQueryString("verify_status");
    if (status == "1") return true;
    return false;
  };

  return (
    <VerifyEmail
      verifyRes={getStatus()}
      trans={translateI10()}
      verifyMes={
        translateI10()[
          getStatus() ? "pin_code_reset_success" : "pin_code_reset_failed"
        ]
      }
      pinReset={true}
    />
  );
};
